var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 42 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.878 37.415L22.312 7.251a2 2 0 013.413 0l18.434 30.164a2 2 0 01-1.707 3.043H5.584a2 2 0 01-1.706-3.043zM22.238 17.5l.321 11.967h3.301l.334-11.967h-3.956zm1.978 18.21c1.397 0 2.25-.803 2.25-2.101 0-1.31-.853-2.114-2.25-2.114-1.385 0-2.25.803-2.25 2.114 0 1.298.865 2.101 2.25 2.101z",
    id: "error-filled_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#fc6666",
    xlinkHref: "#error-filled_svg__a",
    transform: "translate(-3 -6)"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCA0MiAzNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggZD0iTTMuODc4IDM3LjQxNUwyMi4zMTIgNy4yNTFhMiAyIDAgMCAxIDMuNDEzIDBsMTguNDM0IDMwLjE2NGEyIDIgMCAwIDEtMS43MDcgMy4wNDNINS41ODRhMiAyIDAgMCAxLTEuNzA2LTMuMDQzek0yMi4yMzggMTcuNWwuMzIxIDExLjk2N2gzLjMwMWwuMzM0LTExLjk2N2gtMy45NTZ6bTEuOTc4IDE4LjIxYzEuMzk3IDAgMi4yNS0uODAzIDIuMjUtMi4xMDEgMC0xLjMxLS44NTMtMi4xMTQtMi4yNS0yLjExNC0xLjM4NSAwLTIuMjUuODAzLTIuMjUgMi4xMTQgMCAxLjI5OC44NjUgMi4xMDEgMi4yNSAyLjEwMXoiIGlkPSJhIi8+PC9kZWZzPjx1c2UgZmlsbD0iI2ZjNjY2NiIgeGxpbms6aHJlZj0iI2EiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zIC02KSIvPjwvc3ZnPg==";
export { SvgErrorFilled as ReactComponent };